import { useContext, useEffect } from "react";

import {
  InitializeMessage,
  UpdateTaskMessage,
} from "shared/actions/webSocketMessageActions";
import useWebSocket from "shared/hooks/useWebSocket";
import {
  SocketData,
  SocketStatus,
} from "shared/reducers/webSocketMessageReducer";

import BulkReportGenerationIndicator from "components/viewerLists/reportList/BulkReportGenerationIndicator";
import { useAppDispatch, useAppSelector } from "store/hooks";

import { SocketMessageContext } from "./SocketMessageProvider";

const WebSocketGate = () => {
  //TODO: Reevaluate the usefulness of context here, the context currently is the message sending, the redux is the receiving.
  // Choose one or the other when determining websocket use.
  const { socketMessage, setSocketMessage } = useContext(SocketMessageContext);
  const { tasks } = useAppSelector((state) => state.webSocketMessages);
  const dispatch = useAppDispatch();

  const onMessageData = (data: SocketData) => {
    if (data.type === "download_response") {
      if (
        data.status === SocketStatus.SUCCESS ||
        data.status === SocketStatus.FAILED
      ) {
        dispatch(UpdateTaskMessage(data));
      } else if (data.status === SocketStatus.INITIALIZED) {
        dispatch(InitializeMessage(data));
      }
    }
  };

  const socket = useWebSocket("viewer", false, {
    onMessageData,
  });

  useEffect(() => {
    if (socketMessage) {
      if (!socket.ref.current) {
        socket.connect(socketMessage);
        setSocketMessage(null);
      } else if (socket.ref.current.readyState === WebSocket.OPEN) {
        socket.ref.current.send(socketMessage);
        setSocketMessage(null);
      } else {
        socket.ref.current.reconnect &&
          socket.ref.current.reconnect(socketMessage);
        setSocketMessage(null);
      }
    }
  }, [socketMessage]);

  useEffect(() => {
    if (socket.ref.current && !tasks.length) {
      socket.ref.current.close();
    }
  }, [tasks]);

  return (
    <>
      <BulkReportGenerationIndicator />
    </>
  );
};

export default WebSocketGate;
